import AdminNavigationBar from "@/components/adminNavigationBar";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "@/libs/guard/auth-guard";
import { ROLES } from "@/libs/constants/roles";
import ThemeProvider from "@/libs/providers/theme-provider";
import { useUserDenials, useUserPermissions } from "@/libs/hooks/use-user";
import { useAppDispatch, useAppSelector } from "@quest/hooks";
import Loader from "@quest/ui/components/loader";
import { useEffect } from "react";
import { setPermissions } from "@quest/slice/permissions/permission.slice";
import ScrollToTop from "@quest/ui/components/scroll-to-top";
import { getClientIdFromSubdomain } from "@/libs/utils/client-slug";
import { stripPermissionsByDenials } from "@/libs/utils/strip-permissions-by-denials";

function AdminLayout() {
  const { role } = useAppSelector((state) => state.auth);

  return (
    <AuthGuard
      requiredRoles={[ROLES.TENANT_ADMIN, ROLES.TEACHER]}
      redirectTo={role === ROLES.PARENT ? "/parents/passport" : "/"}
    >
      <ThemeProvider>
        <AdminLayoutContent />
      </ThemeProvider>
    </AuthGuard>
  );
}

function AdminLayoutContent() {
  const { role } = useAppSelector((state) => state.auth);

  const {
    data: userPermissions,
    isLoading,
    isError,
    error,
  } = useUserPermissions(role);

  const clientDetails = getClientIdFromSubdomain();

  const isMentor = role === ROLES.TEACHER;

  const { data: userDenials } = useUserDenials(clientDetails, isMentor);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userPermissions) {
      dispatch(
        setPermissions(
          stripPermissionsByDenials(
            userPermissions.permissions,
            userDenials?.denials
          )
        )
      );
    }
  }, [userPermissions, userDenials, dispatch]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-2xl font-bold">
          {error?.message || "Something went wrong"}
        </p>
      </div>
    );
  }

  return (
    <div className="w-[95%] mx-auto flex flex-col gap-5 font-montserrat pb-[0.5rem]">
      <AdminNavigationBar />
      <div className="pl-4 font-montserrat">
        <ScrollToTop />

        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
